import axios from "axios";

export default {

    async getInfo(cnpj) {
        const req = await axios.get(`https://www.receitaws.com.br/v1/cnpj/${cnpj}`);
        return req.data;
    }

}